module.exports = __webpack_public_path__ + "static/media/bg.23cc48d4.jpg";